import InfoToolTip from "../../History/InfoIconTooltip";
import { useSelector, useDispatch } from "react-redux";
import {
  currentSelectedLanguage,
  updateGatewaySettings,
} from "../../../../StateManagement/actions";
import { useEffect, useRef, useState } from "react";
import MultipleIps from "../../../Controls/MultipleIps/MultipleIps";
import Select from "react-select";

import Alert from "../../../Controls/Alerts/Alerts";

import { SettingHistory } from "./SettingHistory";
import TermsOfService from "../TermsOfService";
import {
  updateSettingsData,
  setDefaultSettingsFor,
} from "../../../../StateManagement/actions";
import useValidateSettings from "../hooks/useValidateSettings";
import LoadingSpinner from "../../../Controls/Spinner/LoadingSpinner";

export default function ControlMenu({
  containerClassname,
  label,
  isShowToolTip = false,
  tooltip = "",
  options = [],
  isShowLockIconOnDisable = false,
  controlType,
  companyLevel,
  SideMenuType,
  value,
  settingType,
  level,
  Override,
  Lock,
  settingId,
  placeholder,
  selectAll = false,
  configLevel,
  disableSharevotes,
  isGroupedControl = false,
  showHistory = false,
  eDisclosureSecurityLevels = [],
  isProfileTab = false,
  preSelect = false,
  disableAdminLockedControls = false,
  disableTermsOfService,
  disableOverrideForAdminDocument = false,
  disableLockForAdminDocument = false,
  disableOverrideLockControls = false,
  disableCipherShape = false
}) {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const lookUpData = useSelector((state) => state.settings.lookupData);
  const outerTabSelected = useSelector((state) => state.settings.settingFor);
  const dispatch = useDispatch();
  const { VerifyAddOnEnabled } = useValidateSettings();
  const ddlRef = useRef();
  const customddlRef = useRef();
  const textAreaRef = useRef();
  const textBoxRef = useRef();
  const disabledRadioRef = useRef();
  const enabledRadioRef = useRef();
  const preSelectRef = useRef();
  const eDisclosureSecurityLevelsRef = useRef([]);
  const overrideRef = useRef();
  const lockRef = useRef();
  const childRef = useRef(null);
  const [constmultipleips, setConstMultipleIps] = useState([]);
  const [savedOptions, setSavedOptions] = useState([]);

  const [modalForSettingHistory, setmodalForSettingHistory] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [shareVotes, setShareVotes] = useState(true);
  const [disabledRadioRefChecked, setDisabledRadioRefChecked] = useState(false);
  const [enabledRadioRefChecked, setEnabledRadioRefChecked] = useState(false);
  const customTextBoxRef = useRef();
  const customDropdownRef = useRef();
  const [openLoader, setOpenLoader] = useState(false);
  const isLocked = (!companyLevel && isShowLockIconOnDisable) || Lock === "true";
  // useEffect(() => {
  //   setTimeout(() => {
  //     setAlertMsg("");
  //     setAlertType("");
  //   }, 5000);
  // }, [alertType]);

  const handleSettingHistory = () => {
    setmodalForSettingHistory(true);
  };

  const handleCloseSettingHistory = () => {
    setmodalForSettingHistory(false);
  };

  const customStyles = {
    option: (styles, state) => ({
      ...styles,
      cursor: "pointer",
      menu: (base) => ({
        ...base,
        maxHeight: "100px",
        overflowY: "auto",
      }),
    }),
    control: (styles) => ({
      ...styles,
      cursor: "pointer",
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      menu: (base) => ({
        ...base,
        maxHeight: "100px",
        overflowY: "auto",
      }),
    }),
  };

  useEffect(() => {
    const updateControlValue = () => {
      switch (controlType) {
        case "Dropdown":
          if (ddlRef.current) ddlRef.current.value = value;
          break;
        case "Text Area":
          if (textAreaRef.current) textAreaRef.current.value = value;
          break;
        case "Textbox":
          if (textBoxRef.current) textBoxRef.current.value = value;
          break;
        case "Radio":
          if (disabledRadioRef.current && enabledRadioRef.current) {
            let isEnabled = value === "true";
            if (settingType === "Voting" && value === "false") {
              setShareVotes(false);
            }
            disabledRadioRef.current.checked = !isEnabled;
            enabledRadioRef.current.checked = isEnabled;
            setDisabledRadioRefChecked(!isEnabled);
            setEnabledRadioRefChecked(isEnabled);
          }
          break;
        case "Checkbox":
          if (preSelectRef.current)
            preSelectRef.current.checked = value === "true";
          if (settingType === "Voting" && value === "false") {
            setShareVotes(false);
          }
          break;
        case "custom-Textbox":
          if (childRef.current) {
            if (value && value !== "" && value !== "{}") {
              childRef.current?.setArrayIpList(
                value?.replace(/[{}]/g, "").split(",")
              );
              setConstMultipleIps(value?.replace(/[{}]/g, "").split(","));
            } else {
              childRef.current?.setArrayIpList([]);
              setConstMultipleIps([]);
            }
          }
          break;
        case "custom-Dropdown":
          let selectedValues = value?.replace(/[{}]/g, "").split(",");
          let selectedOptions = options.filter((option) =>
            selectedValues?.includes(option.value)
          );
          setSavedOptions([...selectedOptions]);
          break;
        case "custom-Textbox-Dropdown":
          if (customTextBoxRef.current && customDropdownRef.current) {
            if (value && value !== "") {
              let values = value.split("-");
              customTextBoxRef.current.value = values[0];
              customDropdownRef.current.value = values[1];
            }

          }
          break;
      }
    };
    updateControlValue();
    if (overrideRef.current && Override !== "") {
      overrideRef.current.checked = Override === "true";
    }
    if (lockRef.current && Lock !== "") {
      lockRef.current.checked = Lock === "true";
    }
  }, [
    controlType,
    value,
    level,
    settingType,
    options,
    Override,
    Lock,
    companyLevel,
  ]);

  const onSelectHandler = () => {
    const type = ddlRef.current.id;
    let value = ddlRef.current.value;
    if (type === "DefaultSettingsFor") {
      dispatch(
        setDefaultSettingsFor({
          value: value === "1" ? "RApp" : "Gateway",
        })
      );
      return;
    }
    dispatch(
      updateSettingsData({
        type,
        value,
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
      })
    );
  };

  const onchangeDisableHandler = () => {
    if (enabledRadioRef.current) enabledRadioRef.current.checked = false;
    const type = settingType;
    dispatch(
      updateSettingsData({
        type,
        value: "false",
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
      })
    );
  };
  const onChangeEnableHandler = async () => {
    enabledRadioRef.current.checked = false;
    const type = settingType;
    if (type === "SMSAuthentication") {
      setOpenLoader(true);
      const result = await VerifyAddOnEnabled();
      if (result && result.type === "warning") {
        value = "false";
        disabledRadioRef.current.checked = true;
        enabledRadioRef.current.checked = false;
        setOpenLoader(false);
        setAlertMsg(result.message);
        setAlertType(result.type);
        return;
      }
      setOpenLoader(false);
    } else {
      if (enabledRadioRef.current) enabledRadioRef.current.checked = true;
      if (disabledRadioRef.current) disabledRadioRef.current.checked = false;
    }

    dispatch(
      updateSettingsData({
        type,
        value: "true",
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
      })
    );
  };

  const onTextAreaChangeHandler = () => {
    const type = textAreaRef.current.id;
    let value;
    if (type === "RestrictToDomains" || type.toLowerCase() === "restricttodomains") {
      value = textAreaRef.current.value.replace(/\s+/g, "");
    } else {
      value = textAreaRef.current.value.trimStart();
    }
    textAreaRef.current.value = value;
    dispatch(
      updateSettingsData({
        type,
        value: value,
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
      })
    );
  };

  const onTextboxChangeHandler = () => {
    const type = textBoxRef.current.id;
    let value;

    if (type === "RestrictToDomains" || type.toLowerCase() === "restricttodomains") {
      value = textBoxRef.current.value.replace(/\s+/g, "");
      textBoxRef.current.value = value;
    } else {
      value = textBoxRef.current.value.trimStart();
    }

    if (type.toLowerCase() === "MaxReadsPerReader".toLowerCase()) {
      if (value.length > 6) {
        textBoxRef.current.value = value.substring(0, 6);
        return;
      }

      if (!/^[0-9]*$/.test(value)) {
        textBoxRef.current.value = value.replace(/[^0-9]/g, "");
        return;
      }

      const parsedValue = parseInt(value);
      if (value === "" || value === "0") {
        textBoxRef.current.value = "";
      } else if (parsedValue > 100000) {
        return;
      } else if (parsedValue >= 1 && parsedValue <= 100000) {
        textBoxRef.current.value = parsedValue;
      }
    }
    if (type === "Expires") {
      if (value.length > 7) {
        textBoxRef.current.value = value.substring(0, 7);
        return;
      }
    }

    if (type === "Expires") {
      if (!/^[0-9]*$/.test(value)) {
        textBoxRef.current.value = value.replace(/[^0-9]/g, "");
        return;
      }
    }
    if (type.toLowerCase() === "MaxPrintsPerDocument".toLowerCase() || type.toLowerCase() === "MaxPrintsPerReader".toLowerCase()) {
      if (value.length > 4) {
        textBoxRef.current.value = value.substring(0, 4);
        return;
      }
      let textValue = value.replace(/[^0-9]+/g, "");
      if (textValue == "" || textValue == "0") {
        textBoxRef.current.value = "";
        dispatch(
          updateSettingsData({
            type,
            value: textBoxRef.current.value,
            outerTabSelected:
              outerTabSelected === "User" ? "Personal" : outerTabSelected,
            level,
          })
        );
        return;
      } else if (parseInt(textValue) >= 1 && parseInt(textValue) <= 9999) {
        textBoxRef.current.value = parseInt(textValue);
      }
    }
    if (
      type.toLowerCase() === "MaxViewsPerDocument".toLowerCase() ||
      type.toLowerCase() === "maxViewsPerDocument-Admin".toLowerCase()
    ) {
      if (value.length > 6) {
        textBoxRef.current.value = value.substring(0, 6);
        return;
      }

      if (!/^[0-9]*$/.test(value)) {
        textBoxRef.current.value = value.replace(/[^0-9]/g, "");
        return;
      }

      const parsedValue = parseInt(value);
      if (value == "" || value == "0") {
        textBoxRef.current.value = "";
      } else if (parsedValue > 100000) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_TheMaximumLimitForMaxViewsPerDoc
        );
        setAlertType("warning");
        return;
      } else if (parsedValue >= 1 && parsedValue <= 100000) {
        textBoxRef.current.value = parsedValue;
      }
    }
    dispatch(
      updateSettingsData({
        type,
        value: textBoxRef.current.value,
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
      })
    );
  };

  const onCustomSelectHandler = (event) => {
    const type = customddlRef.current.props.id;
    let optionsvalue = [];
    for (let i = 0; i < event.length; i++) {
      optionsvalue.push(event[i].value);
    }
    savedOptions.current = [...event];
    dispatch(
      updateSettingsData({
        type,
        value: "{" + [...optionsvalue] + "}",
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
      })
    );
  };

  const onPreSelectHandler = () => {
    const type = preSelectRef.current.id;
    const value = preSelectRef.current.checked;
    dispatch(
      updateSettingsData({
        type,
        value: value ? "true" : "false",
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
      })
    );
  };

  const onCheckboxHandler = (e, id) => {
    const type = "EDisclosure";
    const value = eDisclosureSecurityLevelsRef.current[id].checked;
    dispatch(
      updateSettingsData({
        type,
        value: value ? "true" : "false",
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
        securityLevel:
          eDisclosureSecurityLevelsRef.current[id].id.split("_")[1],
      })
    );
  };

  const onCustomTextboxChangeHandler = () => {
    const type = customTextBoxRef.current.id;
    const value = customTextBoxRef.current.value.trim();
    if (value.length > 12) {
      customTextBoxRef.current.value = value.substring(0, 12);
      return;
    }
    dispatch(
      updateSettingsData({
        type,
        value: value + "-" + customDropdownRef.current.value,
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
      })
    );
  };

  const onCustomDropdownChangeHandler = () => {
    const type = customDropdownRef.current.id;
    const value = customDropdownRef.current.value;
    dispatch(
      updateSettingsData({
        type,
        value: customTextBoxRef.current.value + "-" + value,
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
      })
    );
  };

  const onOverrideHandler = () => {
    const type = overrideRef.current.id.split("_")[0];
    dispatch(
      updateSettingsData({
        type,
        value,
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
        isOverride: overrideRef.current.checked ? "true" : "false",
      })
    );
  };

  const onLockHandler = () => {
    const type = lockRef.current.id.split("_")[0];
    dispatch(
      updateSettingsData({
        type,
        value,
        outerTabSelected:
          outerTabSelected === "User" ? "Personal" : outerTabSelected,
        level,
        isLock: lockRef.current.checked ? "true" : "false",
      })
    );
  };

  return (
    <>
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className="alerthist"
        isfromSeetting="true"></Alert>
      {openLoader ? <LoadingSpinner /> : null}
      <div className={containerClassname}>
        <div className="col-sm-3">
          {!selectAll && (
            <>
              <label
                htmlFor={settingType}
                className="col-form-label font-w500 control res-w cursorDefault">
                {label}
              </label>
              {isShowToolTip && (
                <span>
                  <InfoToolTip
                    languageCode={tooltip}
                    classNameInfo={"info-Statistics-stat"}
                    classNameTooltip={"statistics-tooltip"}
                    anchorId={`${label}`}
                  />
                </span>
              )}
            </>
          )}
        </div>

        {selectAll && <div className="col-sm-4"></div>}
        {controlType === "Dropdown" && (
          <div
            className={`col-sm-4 ${disableAdminLockedControls ? "position-relative" : ""
              }`}>
            <select
              className={`form-select form-control red-shadow border-r4 me-4 custom-inputBorder 
             ${isLocked ? "cursor-locked" : "cursor-unlocked"}`}
              id={settingType}
              ref={ddlRef}
              onChange={onSelectHandler}
              disabled={
                disableCipherShape ? true : (companyLevel && !disableAdminLockedControls
                  ? false
                  : isShowLockIconOnDisable)
              }>
              {options.map((option) => (
                <option key={option.key} value={option.key}>
                  {option.keyValue}
                </option>
              ))}
            </select>
            {disableAdminLockedControls && (
              <span className="material-icons setting-lockicon">lock</span>
            )}
          </div>
        )}
        {controlType === "custom-Dropdown" && (
          <div className={`col-sm-4`}>
            <Select
              id={settingType}
              isMulti
              name="colors"
              styles={customStyles}
              options={options}
              value={savedOptions.length > 0 ? [...savedOptions] : null}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={onCustomSelectHandler}
              ref={customddlRef}
              placeholder={selectedLanguage.LstLanguageCodes.UI_Select}
              isDisabled={companyLevel ? false : isShowLockIconOnDisable}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>
        )}
        {controlType === "Text Area" && (
          <div className={`col-sm-4`}>
            <div className="field">
              <textarea
                id={settingType}
                className={`w-100 custom-inputBorder ${isShowLockIconOnDisable && !companyLevel ? " Disablerdb" : ""
                  }`}
                name="message"
                rows="4"
                ref={textAreaRef}
                onChange={onTextAreaChangeHandler}
                placeholder={selectedLanguage.LstLanguageCodes.UI_ThisNotewillbeIncluded}
                disabled={companyLevel ? false : isShowLockIconOnDisable}
                tabindex="4"></textarea>
            </div>
          </div>
        )}
        {controlType === "Textbox" && (
          <div
            className={`col-sm-4 ${disableAdminLockedControls ? "position-relative" : ""
              }`}>
            <input
              id={settingType}
              type="text"
              className={`form-control red-shadow border-r4 custom-inputBorder`}
              ref={textBoxRef}
              onChange={onTextboxChangeHandler}
              disabled={
                companyLevel && !disableAdminLockedControls
                  ? false
                  : isShowLockIconOnDisable
              }
              placeholder={placeholder}
            />
            {companyLevel && disableAdminLockedControls && (
              <span className="material-icons setting-lockicon">lock</span>
            )}
          </div>
        )}
        {controlType === "custom-Textbox" && (
          <div className={`col-sm-4`}>
            <MultipleIps
              className="settings"
              id={settingType}
              type="text"
              isfromSetting={"true"}
              constmultipleips={[...constmultipleips]}
              disabled={companyLevel ? false : isShowLockIconOnDisable}
              display={"none"}
              ref={childRef}
              level={level}
              companyLevel={companyLevel}
              SideMenuType={SideMenuType}></MultipleIps>
          </div>
        )}
        {controlType === "custom-Textbox-Dropdown" && (
          <div className={`col-sm-4`}>
            <div className="input-group idliker-group red-shadow border-r4 custom-inputBorder">
              <input
                type="text"
                className="form-control"
                id={settingType}
                ref={customTextBoxRef}
                placeholder={placeholder}
                onChange={onCustomTextboxChangeHandler}
                disabled={companyLevel ? false : isShowLockIconOnDisable}
              />
              <select id={settingType} className={`form-select ${isLocked ? "cursor-locked" : "cursor-unlocked"}`} ref={customDropdownRef} onChange={onCustomDropdownChangeHandler} disabled={companyLevel ? false : isShowLockIconOnDisable}>
                {options.map((option) => (
                  <option key={option.key} value={option.key}>
                    {option.keyValue}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
        {controlType === "Checkbox" && (
          <>
            {isGroupedControl && eDisclosureSecurityLevels.length > 0 ? (
              <div className="col-sm-4 d-flex align-items-center">
                {eDisclosureSecurityLevels.map((item) => (
                  <div className={`checkbox mt-2 me-2 ${item.disabled || (!companyLevel && isShowLockIconOnDisable) ? "cursor-locked" : "cursor-unlocked"}`} key={item.id}>
                    <label
                      className={`ps-0 ${item.disabled ||
                        (!companyLevel && isShowLockIconOnDisable)
                        ? "disabledEDisclosureGroup"
                        : ""
                        }`}
                      style={{ whiteSpace: "nowrap" }}>
                      <input
                        ref={(el) =>
                          (eDisclosureSecurityLevelsRef.current[item.id] = el)
                        }
                        type="checkbox"
                        id={`chk_${item.level}`}
                        name={`checkbox-group-${item.label}`}
                        disabled={
                          item.disabled ||
                          (!companyLevel && isShowLockIconOnDisable)
                        }
                        checked={item.levelFlag}
                        onChange={(e) => onCheckboxHandler(e, item.id)}
                      />
                      <span className="cr" tabIndex={42}>
                        <i className="cr-icon material-icons">check</i>
                      </span>
                      <span>{item.label}</span>
                    </label>
                  </div>
                ))}
              </div>
            ) : (
              <div className={`col-sm-4`}>
                <div className={`checkbox ${(!companyLevel && isShowLockIconOnDisable) || disableSharevotes ? "cursor-locked" : "cursor-unlocked"}`}>
                  <label
                    className={`ps-0 font-w500 ${disableSharevotes ? "shareVotesDisable cursor-locked" : ""
                      }`}>
                    <input
                      id={settingType}
                      type="checkbox"
                      onChange={onPreSelectHandler}
                      ref={preSelectRef}
                      disabled={
                        disableSharevotes
                          ? true
                          : companyLevel
                            ? false
                            : isShowLockIconOnDisable
                      }
                    />
                    <span className="cr" tabIndex="42">
                      <i className="cr-icon material-icons">check</i>
                    </span>
                    {preSelect &&
                      selectedLanguage.LstLanguageCodes.UI_PreSelect}
                  </label>
                </div>
              </div>
            )}
          </>
        )}
        {controlType === "Radio" && (
          <div className={`col-sm-4`}>
            <span className={`radio me-4 ${(!companyLevel && isShowLockIconOnDisable) || disableSharevotes ? "cursor-locked" : "cursor-unlocked"}`}>
              <input
                id={`Disabled_${settingType}_${level}`}
                type="radio"
                ref={disabledRadioRef}
                onChange={onchangeDisableHandler}
                disabled={
                  disableSharevotes
                    ? true
                    : companyLevel
                      ? false
                      : isShowLockIconOnDisable
                }
              />
              <label
                htmlFor={`Disabled_${settingType}_${level}`}
                className={`radio-label font-w500 control res-w res-left12 ${disableSharevotes && !shareVotes
                  ? "Disablerdb"
                  : !disableSharevotes &&
                    !companyLevel &&
                    isShowLockIconOnDisable &&
                    !disabledRadioRefChecked
                    ? "Disablerdb"
                    : ""
                  }`}>
                {selectedLanguage.LstLanguageCodes.UI_Disabled}
              </label>
            </span>
            <span className={`radio me-4 ${(!companyLevel && isShowLockIconOnDisable) || disableSharevotes ? "cursor-locked" : "cursor-unlocked"}`}>
              <input
                type="radio"
                ref={enabledRadioRef}
                id={`Enabled_${settingType}_${level}`}
                onChange={onChangeEnableHandler}
                disabled={
                  disableSharevotes
                    ? true
                    : companyLevel
                      ? false
                      : isShowLockIconOnDisable
                }
              />
              <label
                htmlFor={`Enabled_${settingType}_${level}`}
                className={`radio-label font-w500 control res-w  res-left12 ${disableSharevotes && shareVotes
                  ? "Disablerdb"
                  : !disableSharevotes &&
                    !companyLevel &&
                    isShowLockIconOnDisable &&
                    !enabledRadioRefChecked
                    ? "Disablerdb"
                    : ""
                  }`}>
                {selectedLanguage.LstLanguageCodes.UI_Enabled}
              </label>
            </span>
          </div>
        )}
        {controlType === "RichTextEditor" && (
          <div
            className={`col-sm-5 ${disableTermsOfService ||
              (!companyLevel && isShowLockIconOnDisable)
              ? "disabledEDisclosureGroup"
              : ""
              }`}>
            <TermsOfService isDisable={disableTermsOfService} content={value} />
          </div>
        )}

        {!isProfileTab && (
          <>
            {companyLevel &&
              configLevel !== "User" &&
              label !==
              selectedLanguage.LstLanguageCodes.UI_DefaultSettingsFor && (
                <>
                  <div
                    className={`${isGroupedControl ? `col-sm-1` : `col-sm-2`
                      } text-center`}>
                    {!isGroupedControl && (
                      <div className="checkbox">
                        {/* mt-12px */}
                        <label
                          className={`ps-0 ${disableSharevotes ||
                            disableOverrideForAdminDocument ||
                            disableAdminLockedControls ||
                            disableOverrideLockControls ||
                            disableCipherShape
                            ? "shareVotesDisable"
                            : ""
                            }`}>
                          <input
                            type="checkbox"
                            id={`${settingType}_override`}
                            onChange={onOverrideHandler}
                            ref={overrideRef}
                            disabled={
                              disableSharevotes ||
                                disableOverrideForAdminDocument ||
                                disableAdminLockedControls ||
                                disableOverrideLockControls ||
                                disableCipherShape
                                ? true
                                : false
                            }
                          />
                          <span className="cr" tabIndex="42">
                            <i className="cr-icon material-icons">check</i>
                          </span>
                        </label>
                      </div>
                    )}
                  </div>
                </>
              )}
            {companyLevel &&
              label !==
              selectedLanguage.LstLanguageCodes.UI_DefaultSettingsFor && (
                <>
                  <div className="col-sm-2 text-center">
                    {!isGroupedControl && (
                      <div className="checkbox">
                        <label
                          className={`ps-0 ${disableSharevotes ||
                            disableLockForAdminDocument ||
                            disableAdminLockedControls ||
                            disableOverrideLockControls ||
                            disableCipherShape
                            ? "shareVotesDisable"
                            : ""
                            }`}>
                          <input
                            type="checkbox"
                            id={`${settingType}_lock`}
                            onChange={onLockHandler}
                            ref={lockRef}
                            disabled={
                              disableSharevotes ||
                                disableLockForAdminDocument ||
                                disableAdminLockedControls ||
                                disableOverrideLockControls ||
                                disableCipherShape
                                ? true
                                : false
                            }
                          />
                          <span className="cr" tabIndex="42">
                            <i className="cr-icon material-icons">check</i>
                          </span>
                        </label>
                      </div>
                    )}
                  </div>
                </>
              )}
            {!companyLevel &&
              !isGroupedControl &&
              label !==
              selectedLanguage.LstLanguageCodes.UI_DefaultSettingsFor && (
                <>
                  <div className={"col-sm-1"}>
                    {!isGroupedControl && isShowLockIconOnDisable && (
                      <label
                        htmlFor={`inputLock-${label}`}
                        className="col-form-label font-w500 control res-w cursorDefault">
                        <span
                          className="material-icons"
                          style={{
                            fontSize: "20px",
                            color: "red",
                          }}>
                          lock
                        </span>
                      </label>
                    )}
                  </div>
                </>
              )}
            {showHistory && (
              <div className="col-sm-1 text-center">
                {!selectAll &&
                  label !==
                  selectedLanguage.LstLanguageCodes.UI_DefaultSettingsFor && (
                    <label
                      htmlFor={`inputHistory-${label}`}
                      className="col-form-label font-w500 control res-w "
                      id={settingId != "" ? settingId : ""}
                      onClick={(e) => handleSettingHistory()}>
                      <span className="material-icons">history</span>
                    </label>
                  )}
              </div>
            )}
          </>
        )}
      </div>
      {modalForSettingHistory && (
        <SettingHistory
          settingId={settingId}
          type={settingType}
          level={level}
          label={label}
          companyLevel={companyLevel}
          closeModal={handleCloseSettingHistory}
        />
      )}
    </>
  );
}

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timerID = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timerID);
    };
  }, [value, delay]);

  return debouncedValue;
}
